import React, { useState } from 'react';
import { Link } from "react-router-dom";

export const LensType = ({ onToggle }) => {
  const [addcart, setaddcart] = useState(false);
  const [counter, setCounter] = useState(1);
  const incrementCount = () => {
    setCounter(counter + 1);
  };
  const decrementCount = () => {
    setCounter((c) => Math.max(c - 1, 1));
  };

  return (
    <div className="flex-row space-y-5">
      <div className="border border-gray-300 rounded-md p-4 flex cursor-pointer items-center gap-10 hover:bg-cyan-50 hover:border-cyan-500 shadow hover:shadow-lg" onClick={() => onToggle(2)}>
        <div>
          <img src="images/single_vision_icon.png" alt="Singlevision" className="w-16" />
        </div>
        <div>
          <p className="font-semibold">Single Vision</p>
          <p className="text-sm text-gray-600">Used for distance or near vision</p>
        </div>
      </div>

      <div className="border border-gray-300 rounded-md p-4 flex cursor-pointer items-center gap-10 hover:bg-cyan-50 hover:border-cyan-500 shadow hover:shadow-lg"
        onClick={() => onToggle(2)}>
        <div>
          <img src="images/progressive_icon.png" alt="Singlevision" className="w-16" />
        </div>
        <div>
          <p className="font-semibold">Progressive</p>
          <p className="text-sm text-gray-600">No-line lenses with three horizons: distance, intermediate, and near</p>
        </div>
      </div>

      <div onClick={() => setaddcart((prevState) => !prevState)} className="border border-gray-300 rounded-md p-6 flex cursor-pointer items-center gap-10 hover:bg-cyan-50 hover:border-cyan-500 shadow hover:shadow-lg">
        <div>
          <img src="images/non_prescription_icon.png" alt="Singlevision" className="w-16" />
        </div>
        <div>
          <p className="font-semibold">Frame Only</p>
          <p className="text-sm text-gray-600">Lens without any prescription</p>
        </div>
      </div>

      {/* add to cart */}
      <div className={addcart === true ? "fixed add_to_cart right-0 bg-white lg:w-1/3 z-[9999] -top-5  h-screen px-5 py-7 overflow-y-auto shadow-xl" : "fixed add_to_cart -right-[114%] bg-white lg:w-1/3 z-[9999] -top-5  h-screen px-5 py-7 overflow-y-auto shadow-xl"}>
        <span className="absolute right-2 font-bold cursor-pointer top-1 text-xl text-gray-500 hover:text-gray-700" onClick={() => setaddcart((prevState) => !prevState)}>x</span>
        <div className="mt-4">
          <h4>Silver Blue Full Rim Square Vincent Chase</h4>
          <div className="flex mt-8 gap-6 justify-center items-center">
            <div><img src="images/product-01.png" alt="product" className="md:w-60 w-32 " /></div>
            <div className="">
              <button type="button" className="bg-gray-300 w-10 h-8 rounded-l" onClick={decrementCount} > - </button>
              <input type="number" min="1" value={counter} className="h-8 w-10 border relative top-[1px]" />
              <button type="button" className="bg-gray-300 w-10 h-8 rounded-r" onClick={incrementCount} > + </button>
            </div>
          </div>
        </div>

        <table class="mt-8 text-left w-full text-sm leading-loose text-gray-500 border-spacing-2 border">
          <tbody>
            <tr>
              <td className="border border-slate-200 p-1">FRAME PRICE</td>
              <td className="border border-slate-200 p-1">$98</td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-1">LENS PACKAGE</td>
              <td className="border border-slate-200 p-1">Thin Anti-Glare_sg $0</td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-1">SUBTOTAL</td>
              <td className="border border-slate-200 p-1">$98</td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-1">Net Amount</td>
              <td className="border border-slate-200 p-1">$98</td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-1">Convenience Fees</td>
              <td className="border border-slate-200 p-1">Free</td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-1 bg-gray-100">Order Total</td>
              <td className="border border-slate-200 p-1 bg-gray-100">$98</td>
            </tr>
          </tbody>
        </table>
        <Link to="/cart" class="bg-cyan-500 text-white w-full mt-6 rounded p-2 tracking-wider block">
          <span class="uppercase text-sm font-light">Proceed to Checkout</span>
          <span class="block text-xs font-light">(You can submit your power at the end)</span>
        </Link>
      </div>
    </div>
  )
}